import {remCalc} from '../../_utils'
import {StyleConfig} from '@chakra-ui/react'

const plpWhiteBanner: StyleConfig = {
    baseStyle: {
        container: {
            width: '100%',
            position: 'relative',
            m: '0 auto',
        },
        textblock: {
            position: {base: 'inherit', xl: 'absolute'},
            top: 0,
            left: 0,
            width: '100%',
            height: {base: 'auto', xl: '100%'},
            direction: 'column',
            justifyContent: 'center',
            textAlign: {base: 'center', xl: 'left'},
            alignItems: {base: 'center', xl: 'baseline'},
            mx: 'auto',
            pl: {base: remCalc(24), xl: remCalc(120)},
        },
    },
}

export default plpWhiteBanner
